import { themeConfig } from './config';

/**
 * Sets **font** CSS variables on `:root` only. Color `--theme-*` values are
 * owned by scoped rules in `globals.css` (`[data-app-theme="public" | "private"]`)
 * so `applyThemeFromConfig` does not override route-class themes after hydration.
 */
export function applyThemeFromConfig() {
  const root = document.documentElement;
  const { fonts } = themeConfig;

  root.style.setProperty('--theme-font-sans', fonts.sans);
  root.style.setProperty('--theme-font-heading', fonts.heading);
}
